export enum StepperContext {
  APPLICATION_FORM_LAYOUT,
  REVIEW_INFORMATION,
  CREATE_EVENT
}

export enum StepperSteps {
  STEP_1 = 'Step 1',
  STEP_2 = 'Step 2',
  STEP_3 = 'Step 3'
}

export enum StepperDescriptions {
  BURSARY_YEAR = 'Select year of bursary',
  ADD_CANDIDATES = 'Add Candidates',
  ALLOCATE_FUNDS = 'Allocate Funds',
  REVIEW_INFORMATION = 'Review Information',
  ADDITIONAL_INFORMATION = 'Additional Information',
  QUESTIONNAIRE = 'Questionnaire',
  EVENT_DETAILS = 'Event details',
  ADD_INVITES = 'Add Invites',
  REVIEW = 'Review'
}
